import { useSelector } from 'react-redux';
import { decryptData } from '../../../utils/Crypto';
import { RootState } from '@store/online/index';
import { AuthUser, UserAddress } from '@store/online/auth/authTypes';
import { useMemo } from 'react';

const useAuthUser = () => {
  const user: AuthUser = useSelector((state: RootState) => state.auth.user);
  const decryptedUser = useMemo(() => {
    if (!user) return null;

    const result: Partial<AuthUser> = {};

    for (const key of Object.keys(user) as (keyof AuthUser)[]) {
      const value = user[key];

      if (key === 'address' && typeof value === 'object' && value !== null) {
        const decryptedAddress: Partial<UserAddress> = {};
        for (const addrKey of Object.keys(value) as (keyof UserAddress)[]) {
          const addrValue = value[addrKey];
          decryptedAddress[addrKey] = typeof addrValue === 'string' ? decryptData(addrValue) : addrValue;
        }
        result[key] = decryptedAddress as AuthUser['address'];
      } else {
        result[key] = typeof value === 'string' ? decryptData(value) : value;
      }
    }

    return result;
  }, [user]);
  return decryptedUser;
};

export default useAuthUser;
